(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mg-cat-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-cat-strip')) {
    /**
     * Category strip behaviour: edge fades, arrows, mouse drag, keeping focus/active items
     * in view, and client-side matching for filtered ("?filter...") links.
     * All listeners are removed on disconnect (theme editor re-renders).
     */
    class MgCatStrip extends HTMLElement {
      #abort = null;
      #observer = null;
      #io = null;
      #frame = 0;
      #styles = null;
      #drag = null;
      #dragMoved = false;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.slider = this.querySelector('[data-mg-slider]');
        this.list = this.querySelector('[data-mg-list]');
        this.prev = this.querySelector('[data-mg-arrow="prev"]');
        this.next = this.querySelector('[data-mg-arrow="next"]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.#matchQueryLinks();
        this.#watchCounts();

        if (!this.slider || !this.list) return;

        this.prev?.addEventListener('click', () => this.#scrollByPage(-1), { signal });
        this.next?.addEventListener('click', () => this.#scrollByPage(1), { signal });
        this.list.addEventListener('scroll', () => this.#requestUpdate(), { passive: true, signal });

        // Keep keyboard focus clear of the edge fade and arrows
        this.list.addEventListener('focusin', (event) => {
          const item = event.target.closest('.mg-cs__item');
          if (item && !this.#isFullyVisible(item)) this.#reveal(item, true);
        }, { signal });

        if (this.slider.dataset.drag === 'true') this.#bindDrag(signal);

        // A resize can cross a breakpoint (grid <-> slider), so drop the cached computed styles too.
        // ResizeObserver fires once right after the first layout: the initial measure runs there,
        // so startup never forces a synchronous reflow.
        let measured = false;
        const firstMeasure = () => {
          measured = true;
          this.#reveal(this.list.querySelector('.mg-cs__item.is-active'), false);
          this.#update();
        };
        const onResize = () => {
          this.#styles = null;
          if (!measured) return firstMeasure();
          this.#requestUpdate();
        };
        if ('ResizeObserver' in window) {
          this.#observer = new ResizeObserver(onResize);
          this.#observer.observe(this.list);
        } else {
          window.addEventListener('resize', onResize, { passive: true, signal });
          this.#frame = requestAnimationFrame(() => {
            this.#frame = 0;
            firstMeasure();
          });
        }

        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) this.#reveal(event.target.closest('.mg-cs__item'), true);
        }, { signal });

      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#observer?.disconnect();
        this.#io?.disconnect();
        if (this.#frame) cancelAnimationFrame(this.#frame);
        this.#frame = 0;
        this.#styles = null;
      }

      /* ---------- Live counts (shared mg-size-counts endpoint) ---------- */

      #watchCounts() {
        if (!this.querySelector('[data-count-url]')) return;
        // Wait for an idle moment so the counts never compete with the hero image / LCP
        const start = () => {
          const idle = window.requestIdleCallback || ((callback) => setTimeout(callback, 200));
          idle(() => this.#loadCounts(), { timeout: 2000 });
        };
        if (!('IntersectionObserver' in window)) return start();
        this.#io = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.#io.disconnect();
          start();
        }, { rootMargin: '300px 0px' });
        this.#io.observe(this);
      }

      async #loadCounts() {
        const { signal } = this.#abort;
        const targets = new Map();

        for (const el of this.querySelectorAll('[data-count-url]')) {
          let url;
          try {
            url = new URL(el.dataset.countUrl, window.location.origin);
          } catch (error) {
            continue;
          }
          if (url.origin !== window.location.origin) continue;
          // Only filters change the count; sort/page params would just split the cache
          for (const key of [...url.searchParams.keys()]) {
            if (!key.startsWith('filter.')) url.searchParams.delete(key);
          }
          url.searchParams.sort();
          const key = url.pathname + url.search;
          if (!targets.has(key)) targets.set(key, []);
          targets.get(key).push(el);
        }

        // Small request pool so a long strip never floods the network
        const queue = [...targets];
        const worker = async () => {
          while (queue.length && !signal.aborted) {
            const [key, els] = queue.shift();
            try {
              const count = await this.#fetchCount(key, signal);
              for (const el of els) this.#renderCount(el, count);
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }
        };
        await Promise.all(Array.from({ length: Math.min(3, queue.length) }, worker));
      }

      async #fetchCount(key, signal) {
        // Same cache key format as shop-by-size / brand / condition, so they share results
        const cacheKey = `mg_sbs_counts_${key}`;
        let data = null;
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached && Date.now() - cached.t < 5 * 60 * 1000 && cached.total !== undefined) data = cached;
        } catch (error) { /* storage unavailable */ }

        if (!data) {
          const requestUrl = new URL(key, window.location.origin);
          requestUrl.searchParams.set('section_id', 'mg-size-counts');
          const response = await fetch(requestUrl, { signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const json = doc.querySelector('[data-mg-filter-counts]');
          if (!json) throw new Error('mg-size-counts section missing');
          const { filters, total } = JSON.parse(json.textContent);
          data = { t: Date.now(), filters, total };
          try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch (error) { /* storage full */ }
        }

        return this.#inStock(data);
      }

      /**
       * One-of-one stock sells out, so prefer the Availability filter's "In stock" count.
       * Falls back to the total when the Availability filter isn't enabled in Search & Discovery.
       */
      #inStock({ filters = [], total }) {
        const availability = filters.find((filter) => filter.param === 'filter.v.availability');
        const inStock = availability?.values.find((v) => String(v.value) === '1');
        return inStock ? inStock.count : total;
      }

      #renderCount(el, count) {
        if (typeof count !== 'number') return;
        const { countLabel = '[count] items', countLabelOne = '1 item', countLabelZero = '' } = this.dataset;
        let text = countLabel.includes('[count]') ? countLabel : `[count] ${countLabel}`;
        if (count === 1) text = countLabelOne;
        if (count === 0) text = countLabelZero;
        if (!text) return;

        const sr = document.createElement('span');
        sr.className = 'mg-cs__sr';
        sr.textContent = ', ';
        el.replaceChildren(sr, text.replace('[count]', count.toLocaleString()));
        el.classList.add('is-loaded');
      }

      #normalizePath(path) {
        const localeRoot = (window.Shopify?.routes?.root || '/').toLowerCase().replace(/\/+$/, '');
        let value = (path || '/').toLowerCase();
        if (localeRoot && (value === localeRoot || value.startsWith(`${localeRoot}/`))) value = value.slice(localeRoot.length);
        if (value.length > 1) value = value.replace(/\/+$/, '');
        return value || '/';
      }

      #setActive(item, exact) {
        for (const el of this.querySelectorAll('.mg-cs__item.is-active')) {
          el.classList.remove('is-active');
          el.querySelector('[aria-current]')?.removeAttribute('aria-current');
        }
        item.classList.add('is-active');
        item.querySelector('a.mg-cs__link')?.setAttribute('aria-current', exact ? 'page' : 'true');
      }

      #matchQueryLinks() {
        const candidates = this.querySelectorAll('[data-mg-query]');
        if (!candidates.length) return;

        const here = this.#normalizePath(window.location.pathname);
        const params = new URLSearchParams(window.location.search);
        let best = null;
        let bestScore = 0;
        let bestExact = false;

        for (const item of candidates) {
          let url;
          try {
            url = new URL(item.dataset.mgQuery, window.location.origin);
          } catch (error) {
            continue;
          }
          if (url.origin !== window.location.origin || this.#normalizePath(url.pathname) !== here) continue;

          let score = 0;
          let matches = true;
          for (const [key, value] of url.searchParams) {
            if (params.getAll(key).includes(value)) {
              score += 1;
            } else {
              matches = false;
            }
          }
          if (matches && score > bestScore) {
            best = item;
            bestScore = score;
            bestExact = [...params.keys()].filter((key) => key !== 'page' && key !== 'sort_by').length === score;
          }
        }

        if (best) this.#setActive(best, bestExact);
      }

      /** Direction / overflow / gap only change with breakpoints, so read them once per resize */
      #listStyles() {
        if (!this.#styles) {
          const style = window.getComputedStyle(this.list);
          this.#styles = {
            rtl: style.direction === 'rtl',
            overflow: style.overflowX !== 'visible',
            gap: parseFloat(style.columnGap) || 0
          };
        }
        return this.#styles;
      }

      #isRtl() {
        return this.#listStyles().rtl;
      }

      #isScrollable() {
        return this.#listStyles().overflow && this.list.scrollWidth - this.list.clientWidth > 2;
      }

      #requestUpdate() {
        if (!this.#frame) this.#frame = requestAnimationFrame(() => this.#update());
      }

      #update() {
        this.#frame = 0;
        const scrollable = this.#isScrollable();
        const max = this.list.scrollWidth - this.list.clientWidth;
        const position = Math.abs(this.list.scrollLeft);
        const atStart = !scrollable || position <= 2;
        const atEnd = !scrollable || position >= max - 2;

        this.slider.dataset.overflow = String(scrollable);
        this.slider.dataset.atStart = String(atStart);
        this.slider.dataset.atEnd = String(atEnd);
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
      }

      #pageSize() {
        const item = this.list.querySelector('.mg-cs__item');
        if (!item) return this.list.clientWidth;
        const { gap } = this.#listStyles();
        const unit = item.getBoundingClientRect().width + gap;
        // Scroll one "page" minus one item so the shopper keeps a visual anchor
        const perPage = Math.max(1, Math.floor((this.list.clientWidth + gap) / unit) - 1);
        return perPage * unit;
      }

      #scrollByPage(direction) {
        const distance = direction * this.#pageSize() * (this.#isRtl() ? -1 : 1);
        this.list.scrollBy({ left: distance, behavior: this.reduceMotion.matches ? 'auto' : 'smooth' });
      }

      #isFullyVisible(item) {
        const margin = 24;
        const listRect = this.list.getBoundingClientRect();
        const rect = item.getBoundingClientRect();
        return rect.left >= listRect.left + margin && rect.right <= listRect.right - margin;
      }

      #reveal(item, smooth) {
        if (!item || !this.#isScrollable()) return;
        const listRect = this.list.getBoundingClientRect();
        const rect = item.getBoundingClientRect();
        const offset = rect.left - listRect.left - (listRect.width - rect.width) / 2;
        this.list.scrollBy({ left: offset, behavior: smooth && !this.reduceMotion.matches ? 'smooth' : 'auto' });
      }

      #bindDrag(signal) {
        const endDrag = () => {
          if (!this.#drag) return;
          this.#drag = null;
          this.slider.classList.remove('is-dragging');
        };

        this.list.addEventListener('pointerdown', (event) => {
          this.#dragMoved = false;
          if (event.pointerType !== 'mouse' || event.button !== 0 || !this.#isScrollable()) return;
          this.#drag = { x: event.clientX, left: this.list.scrollLeft, id: event.pointerId };
        }, { signal });

        this.list.addEventListener('pointermove', (event) => {
          if (!this.#drag) return;
          const delta = event.clientX - this.#drag.x;
          if (!this.#dragMoved && Math.abs(delta) > 6) {
            this.#dragMoved = true;
            this.slider.classList.add('is-dragging');
            this.list.setPointerCapture?.(this.#drag.id);
          }
          if (this.#dragMoved) this.list.scrollLeft = this.#drag.left - delta;
        }, { signal });

        this.list.addEventListener('pointerup', endDrag, { signal });
        this.list.addEventListener('pointercancel', endDrag, { signal });
        this.list.addEventListener('lostpointercapture', endDrag, { signal });

        // Swallow the click that ends a drag so it doesn't navigate
        this.list.addEventListener('click', (event) => {
          if (!this.#dragMoved) return;
          event.preventDefault();
          event.stopPropagation();
          this.#dragMoved = false;
        }, { capture: true, signal });

        this.list.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      }
    }

    customElements.define('mg-cat-strip', MgCatStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-contact-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-contact-page')) {
    /**
     * Contact page: focus the success/error message after submit, prevent double
     * submits, and show an "away" status outside business hours (Pakistan time).
     */
    class MgContactPage extends HTMLElement {
      #abort = null;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        const feedback = this.querySelector('[data-form-feedback]');
        if (feedback) {
          requestAnimationFrame(() => {
            feedback.scrollIntoView({ block: 'center', behavior: 'auto' });
            feedback.focus({ preventScroll: true });
          });
        }

        const form = this.querySelector('[data-mg-contact-form]');
        const submit = this.querySelector('[data-submit]');
        const startedAt = Date.now();
        form?.addEventListener('submit', (event) => {
          // Basic bot filtering (Shopify's own spam protection still runs server-side)
          const honeypot = form.querySelector('[data-hp]');
          if ((honeypot && honeypot.value) || Date.now() - startedAt < 2500) {
            event.preventDefault();
            return;
          }
          if (!form.checkValidity()) return;
          submit?.setAttribute('disabled', '');
          submit?.classList.add('is-sending');
        }, { signal });

        // Coming back via the browser's back button restores the page from cache with the button still disabled
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          submit?.removeAttribute('disabled');
          submit?.classList.remove('is-sending');
        }, { signal });

        this.#applyHours();
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }

      #applyHours() {
        const { hoursOpen, hoursClose, hoursTz, offlineStatus } = this.dataset;
        if (hoursOpen === undefined) return;
        let hour;
        try {
          hour = Number(new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hourCycle: 'h23', timeZone: hoursTz }).format(new Date()));
        } catch (e) {
          return;
        }
        const open = Number(hoursOpen);
        const close = Number(hoursClose);
        let isOpen = true;
        if (open < close) isOpen = hour >= open && hour < close;
        else if (open > close) isOpen = hour >= open || hour < close;
        if (isOpen) return;

        const status = this.querySelector('[data-status]');
        status?.classList.add('is-offline');
        const text = this.querySelector('[data-status-text]');
        if (text && offlineStatus) text.textContent = offlineStatus;
      }
    }

    customElements.define('mg-contact-page', MgContactPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-pillar-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-pillar-grid')) {
    /** Mobile carousel state: edge fade + progress dots. No-op for grid layouts. */
    class MgPillarGrid extends HTMLElement {
      #abort = null;
      #observer = null;
      #frame = 0;

      connectedCallback() {
        if (!this.hasAttribute('data-scroll')) return;
        this.list = this.querySelector('[data-pg-list]');
        this.dots = [...this.querySelectorAll('.mg-pg__dot')];
        if (!this.list) return;

        this.#abort = new AbortController();
        this.list.addEventListener('scroll', () => this.#requestUpdate(), { passive: true, signal: this.#abort.signal });

        // ResizeObserver fires once right after the first layout, so measuring there never forces a reflow
        if ('ResizeObserver' in window) {
          this.#observer = new ResizeObserver(() => this.#update());
          this.#observer.observe(this.list);
        } else {
          this.#requestUpdate();
        }
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#observer?.disconnect();
        if (this.#frame) cancelAnimationFrame(this.#frame);
      }

      #requestUpdate() {
        if (!this.#frame) this.#frame = requestAnimationFrame(() => this.#update());
      }

      #update() {
        this.#frame = 0;
        const { list } = this;
        const max = list.scrollWidth - list.clientWidth;
        const scrollable = window.getComputedStyle(list).overflowX !== 'visible' && max > 2;
        const position = Math.abs(list.scrollLeft);

        this.dataset.overflow = String(scrollable);
        this.dataset.atEnd = String(!scrollable || position >= max - 4);

        if (!scrollable || !this.dots.length) return;
        const index = Math.round((position / max) * (this.dots.length - 1));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-current', i === index));
      }
    }

    customElements.define('mg-pillar-grid', MgPillarGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-promo-sale-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-promo-sale')) {
    /**
     * Promo banner behaviour: coupon copy, scarcity fill, countdown (with optional auto-hide),
     * ticker pause button + off-screen pause. Everything is cleaned up on disconnect.
     */
    class MgPromoSale extends HTMLElement {
      #abort = null;
      #timer = 0;
      #observers = [];

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.isEditor = Boolean(window.Shopify?.designMode);

        for (const btn of this.querySelectorAll('[data-mg-copy-btn]')) {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.#copy(btn);
          }, { signal });
        }

        this.#initScarcity();
        this.#initCountdown();
        this.#initTickers(signal);
      }

      disconnectedCallback() {
        this.#abort?.abort();
        clearInterval(this.#timer);
        this.#observers.forEach((observer) => observer.disconnect());
        this.#observers = [];
      }

      async #copy(btn) {
        const box = btn.closest('[data-mg-coupon-box]');
        const code = box?.querySelector('[data-mg-code]')?.dataset.mgCode?.trim();
        const status = box?.querySelector('[data-mg-copy-status]');
        if (!code) return;

        try {
          await navigator.clipboard.writeText(code);
        } catch (error) {
          const ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.cssText = 'position:fixed;left:-9999px';
          document.body.append(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) { /* ignore */ }
          ta.remove();
        }

        btn.classList.add('is-copied');
        if (status) status.textContent = `Promo code ${code} copied`;
        setTimeout(() => {
          btn.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 2400);
      }

      #initScarcity() {
        for (const fill of this.querySelectorAll('[data-mg-fill]')) {
          const pct = parseFloat(fill.dataset.mgFill) || 0;
          if (this.reduceMotion || !('IntersectionObserver' in window)) {
            fill.style.width = `${pct}%`;
            continue;
          }
          const io = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            fill.style.width = `${pct}%`;
            io.disconnect();
          }, { threshold: 0.15 });
          io.observe(fill);
          this.#observers.push(io);
        }
      }

      // "YYYY-MM-DD HH:MM" (or date only = 23:59) pinned to the chosen UTC offset,
      // so the deal ends at the same moment for every visitor.
      #parseTarget(str, offset) {
        const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::\d{2})?)?$/.exec(String(str || '').trim());
        if (!m) return Date.parse(str);
        const pad = (n) => String(n).padStart(2, '0');
        const hh = m[4] === undefined ? 23 : Number(m[4]);
        const mm = m[5] === undefined ? 59 : Number(m[5]);
        return new Date(`${m[1]}-${pad(m[2])}-${pad(m[3])}T${pad(hh)}:${pad(mm)}:00${offset || '+05:00'}`).getTime();
      }

      #initCountdown() {
        const pad = (n) => String(n).padStart(2, '0');
        const timers = [...this.querySelectorAll('[data-mg-countdown]')].map((el) => ({
          el,
          target: this.#parseTarget(el.dataset.mgCountdown, el.dataset.mgTz),
          hide: el.hasAttribute('data-mg-hide-on-end'),
          d: el.querySelector('[data-days]'),
          h: el.querySelector('[data-hours]'),
          m: el.querySelector('[data-mins]'),
          s: el.querySelector('[data-secs]'),
          expired: el.querySelector('[data-mg-expired]')
        })).filter((t) => !Number.isNaN(t.target));
        if (!timers.length) return;

        const tick = () => {
          const now = Date.now();
          let live = 0;
          for (const t of timers) {
            const diff = t.target - now;
            if (diff <= 0) {
              t.el.classList.add('is-expired');
              if (t.expired) t.expired.hidden = false;
              if (t.hide && !this.isEditor) this.hidden = true;
              continue;
            }
            live += 1;
            t.el.classList.remove('is-expired');
            if (t.expired) t.expired.hidden = true;
            if (t.d) t.d.textContent = pad(Math.floor(diff / 86400000));
            if (t.h) t.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
            if (t.m) t.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
            if (t.s) t.s.textContent = pad(Math.floor((diff % 60000) / 1000));
          }
          if (!live) {
            done = true;
            stop();
          }
        };

        let done = false;
        const stop = () => {
          clearInterval(this.#timer);
          this.#timer = 0;
        };
        const start = () => {
          if (done || this.#timer) return;
          tick();
          if (!done) this.#timer = setInterval(tick, 1000);
        };

        tick();
        if (done) return;
        if (!('IntersectionObserver' in window)) {
          start();
          return;
        }

        // Only tick while a timer is on-screen (saves CPU/battery); it catches up instantly on return.
        const visible = new Set();
        const io = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
          }
          if (visible.size) start();
          else stop();
        });
        timers.forEach((t) => io.observe(t.el));
        this.#observers.push(io);
      }

      #initTickers(signal) {
        const tickers = [...this.querySelectorAll('[data-mg-ticker]')];
        if (!tickers.length) return;

        for (const btn of this.querySelectorAll('[data-mg-ticker-toggle]')) {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            const paused = !tickers[0].classList.contains('is-paused');
            for (const ticker of tickers) ticker.classList.toggle('is-paused', paused);
            for (const b of this.querySelectorAll('[data-mg-ticker-toggle]')) {
              b.setAttribute('aria-pressed', String(paused));
              b.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
            }
          }, { signal });
        }

        // Save CPU/battery: stop the marquee while it's off-screen
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            for (const entry of entries) entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
          });
          tickers.forEach((ticker) => io.observe(ticker));
          this.#observers.push(io);
        }
      }
    }

    customElements.define('mg-promo-sale', MgPromoSale);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-shop-by-brand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-brand-grid')) {
    /**
     * Brand grid: mobile carousel fade, and live counts for Search & Discovery filter links
     * (e.g. /collections/all?filter.p.vendor=Nike) via the shared mg-size-counts section.
     * Counts load only when the section is near the viewport.
     */
    class MgBrandGrid extends HTMLElement {
      #abort = null;
      #ro = null;
      #io = null;
      #frame = 0;

      connectedCallback() {
        this.#abort = new AbortController();
        if (this.hasAttribute('data-scroll')) this.#bindFade();
        if (this.hasAttribute('data-counts') && this.querySelector('[data-count-link]')) this.#watchCounts();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#ro?.disconnect();
        this.#io?.disconnect();
        if (this.#frame) cancelAnimationFrame(this.#frame);
        this.#frame = 0;
      }

      #bindFade() {
        const list = this.querySelector('[data-br-list]');
        if (!list) return;
        // overflow-x only changes across breakpoints, so it is re-read on resize, not on every scroll
        let overflows = null;
        const update = () => {
          this.#frame = 0;
          if (overflows === null) overflows = getComputedStyle(list).overflowX !== 'visible';
          const max = list.scrollWidth - list.clientWidth;
          const scrollable = overflows && max > 2;
          this.dataset.overflow = String(scrollable);
          this.dataset.atEnd = String(!scrollable || Math.abs(list.scrollLeft) >= max - 4);
        };
        // Scroll updates are batched into one animation frame
        const request = () => {
          if (!this.#frame) this.#frame = requestAnimationFrame(update);
        };
        list.addEventListener('scroll', request, { passive: true, signal: this.#abort.signal });
        // ResizeObserver fires once right after the first layout, so measuring there never forces a reflow
        if ('ResizeObserver' in window) {
          this.#ro = new ResizeObserver(() => {
            overflows = null;
            update();
          });
          this.#ro.observe(list);
        } else {
          request();
        }
      }

      #watchCounts() {
        if (!('IntersectionObserver' in window)) return this.#loadCounts();
        this.#io = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.#io.disconnect();
          this.#loadCounts();
        }, { rootMargin: '400px 0px' });
        this.#io.observe(this);
      }

      async #loadCounts() {
        const groups = new Map();
        for (const link of this.querySelectorAll('[data-count-link]')) {
          const url = new URL(link.getAttribute('href'), window.location.origin);
          if (!groups.has(url.pathname)) groups.set(url.pathname, []);
          groups.get(url.pathname).push({ link, url });
        }

        for (const [path, items] of groups) {
          try {
            const filters = await this.#fetchFilters(path);
            const lookup = new Map();
            for (const filter of filters) {
              for (const v of filter.values) lookup.set(`${filter.param.toLowerCase()}|${String(v.value).trim().toLowerCase()}`, v.count);
            }
            for (const { link, url } of items) {
              const entry = [...url.searchParams].find(([key]) => key.startsWith('filter.') && !key.startsWith('filter.v.price'));
              const count = entry ? lookup.get(`${entry[0].toLowerCase()}|${entry[1].trim().toLowerCase()}`) : undefined;
              const el = link.querySelector('[data-count]');
              if (!el || count === undefined) continue;
              const sr = document.createElement('span');
              sr.className = 'mg-brands__sr';
              sr.textContent = ', ';
              el.replaceChildren(sr, this.dataset.countLabel.replace('[count]', count));
            }
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }
      }

      async #fetchFilters(path) {
        const cacheKey = `mg_sbs_counts_${path}`;
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached && Date.now() - cached.t < 5 * 60 * 1000) return cached.filters;
        } catch (e) { /* ignore */ }

        const requestUrl = new URL(path, window.location.origin);
        requestUrl.searchParams.set('section_id', 'mg-size-counts');
        const response = await fetch(requestUrl, { signal: this.#abort.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const json = doc.querySelector('[data-mg-filter-counts]');
        if (!json) throw new Error('mg-size-counts section missing');
        const { filters, total } = JSON.parse(json.textContent);
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), filters, total })); } catch (e) { /* ignore */ }
        return filters;
      }
    }

    customElements.define('mg-brand-grid', MgBrandGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-shop-by-condition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-condition-grid')) {
    /**
     * Condition grid: mobile carousel fade, and live counts for Search & Discovery filter links
     * via the shared mg-size-counts section. Counts load only when the section is near the viewport.
     */
    class MgConditionGrid extends HTMLElement {
      #abort = null;
      #ro = null;
      #io = null;

      connectedCallback() {
        this.#abort = new AbortController();
        if (this.hasAttribute('data-scroll')) this.#bindFade();
        if (this.hasAttribute('data-counts') && this.querySelector('[data-count-link]')) this.#watchCounts();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#ro?.disconnect();
        this.#io?.disconnect();
      }

      #bindFade() {
        const list = this.querySelector('[data-cd-list]');
        if (!list) return;
        const update = () => {
          const max = list.scrollWidth - list.clientWidth;
          const scrollable = getComputedStyle(list).overflowX !== 'visible' && max > 2;
          this.dataset.overflow = String(scrollable);
          this.dataset.atEnd = String(!scrollable || Math.abs(list.scrollLeft) >= max - 4);
        };
        list.addEventListener('scroll', update, { passive: true, signal: this.#abort.signal });
        // ResizeObserver fires once right after the first layout, so measuring there never forces a reflow
        if ('ResizeObserver' in window) {
          this.#ro = new ResizeObserver(update);
          this.#ro.observe(list);
        } else {
          const signal = this.#abort.signal;
          requestAnimationFrame(() => { if (!signal.aborted) update(); });
        }
      }

      #watchCounts() {
        if (!('IntersectionObserver' in window)) return this.#loadCounts();
        this.#io = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.#io.disconnect();
          this.#loadCounts();
        }, { rootMargin: '400px 0px' });
        this.#io.observe(this);
      }

      async #loadCounts() {
        const groups = new Map();
        for (const link of this.querySelectorAll('[data-count-link]')) {
          const url = new URL(link.getAttribute('href'), window.location.origin);
          if (!groups.has(url.pathname)) groups.set(url.pathname, []);
          groups.get(url.pathname).push({ link, url });
        }

        for (const [path, items] of groups) {
          try {
            const filters = await this.#fetchFilters(path);
            const lookup = new Map();
            for (const filter of filters) {
              for (const v of filter.values) lookup.set(`${filter.param.toLowerCase()}|${String(v.value).trim().toLowerCase()}`, v.count);
            }
            for (const { link, url } of items) {
              const entry = [...url.searchParams].find(([key]) => key.startsWith('filter.') && !key.startsWith('filter.v.price'));
              const count = entry ? lookup.get(`${entry[0].toLowerCase()}|${entry[1].trim().toLowerCase()}`) : undefined;
              const el = link.closest('.mg-cond__item')?.querySelector('[data-count]');
              if (el && count !== undefined) el.textContent = this.dataset.countLabel.replace('[count]', count);
            }
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }
      }

      async #fetchFilters(path) {
        const cacheKey = `mg_sbs_counts_${path}`;
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached && Date.now() - cached.t < 5 * 60 * 1000) return cached.filters;
        } catch (e) { /* ignore */ }

        const requestUrl = new URL(path, window.location.origin);
        requestUrl.searchParams.set('section_id', 'mg-size-counts');
        const response = await fetch(requestUrl, { signal: this.#abort.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const json = doc.querySelector('[data-mg-filter-counts]');
        if (!json) throw new Error('mg-size-counts section missing');
        const { filters, total } = JSON.parse(json.textContent);
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), filters, total })); } catch (e) { /* ignore */ }
        return filters;
      }
    }

    customElements.define('mg-condition-grid', MgConditionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-shop-by-size"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-shop-by-size')) {
    /**
     * Shop by size: ARIA tabs (arrows / Home / End), tab-bar edge fades, restoring the
     * last-used tab, and remembering the shopper's last chosen size per category.
     */
    class MgShopBySize extends HTMLElement {
      #abort = null;
      #observer = null;
      #countsObserver = null;
      #countsStarted = false;
      #countsLoaded = new Set();

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.tabs = [...this.querySelectorAll('[data-sbs-tab]')];
        this.panels = [...this.querySelectorAll('[data-sbs-panel]')];
        this.tablist = this.querySelector('[data-sbs-tablist]');
        this.tabKey = `mg_sbs_tab_${this.dataset.sectionId}`;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, { persist: true }), { signal });
          tab.addEventListener('keydown', (event) => this.#onKeydown(event, index), { signal });
        });

        if (this.tablist) {
          this.tablist.addEventListener('scroll', () => this.#updateFades(), { passive: true, signal });
          // ResizeObserver fires once right after the first layout, so measuring there never forces a reflow
          if ('ResizeObserver' in window) {
            this.#observer = new ResizeObserver(() => this.#updateFades());
            this.#observer.observe(this.tablist);
          } else {
            requestAnimationFrame(() => { if (!signal.aborted) this.#updateFades(); });
          }
        }

        // Context (current collection/product) wins; otherwise restore the last tab this session
        if (this.tabs.length && !this.hasAttribute('data-context-tab')) {
          const saved = Number(this.#get('sessionStorage', this.tabKey));
          if (Number.isInteger(saved) && saved > 0 && saved < this.tabs.length) this.select(saved, { scroll: false });
        }

        if (this.hasAttribute('data-remember')) this.#initRememberedSize(signal);
        if (this.hasAttribute('data-counts')) this.#watchCounts();

        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.indexOf(event.target);
          if (index >= 0) this.select(index);
        }, { signal });
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#observer?.disconnect();
        this.#countsObserver?.disconnect();
      }

      select(index, { focus = false, persist = false, scroll = true } = {}) {
        this.tabs.forEach((tab, i) => {
          const current = i === index;
          tab.setAttribute('aria-selected', String(current));
          tab.tabIndex = current ? 0 : -1;
        });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });

        const tab = this.tabs[index];
        if (!tab) return;
        if (focus) tab.focus();
        if (scroll && this.tablist) this.#scrollTabIntoView(tab);
        if (persist) this.#set('sessionStorage', this.tabKey, String(index));
        if (this.#countsStarted) this.#loadCounts(this.panels[index]);
      }

      #onKeydown(event, index) {
        const last = this.tabs.length - 1;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const next = rtl ? 'ArrowLeft' : 'ArrowRight';
        const prev = rtl ? 'ArrowRight' : 'ArrowLeft';
        let target = -1;
        if (event.key === next) target = index === last ? 0 : index + 1;
        else if (event.key === prev) target = index === 0 ? last : index - 1;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = last;
        if (target < 0) return;
        event.preventDefault();
        this.select(target, { focus: true, persist: true });
      }

      #scrollTabIntoView(tab) {
        // Scroll only the tab bar — never the page
        const bar = this.tablist;
        const barRect = bar.getBoundingClientRect();
        const rect = tab.getBoundingClientRect();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const pad = parseFloat(getComputedStyle(bar).paddingLeft) || 0;
        if (rect.left < barRect.left + pad || rect.right > barRect.right - pad) {
          bar.scrollBy({ left: rect.left - barRect.left - pad, behavior: reduce ? 'auto' : 'smooth' });
        }
      }

      #updateFades() {
        const bar = this.tablist;
        const max = bar.scrollWidth - bar.clientWidth;
        const pos = Math.abs(bar.scrollLeft);
        this.dataset.tabsStart = String(max <= 8 || pos <= 8);
        this.dataset.tabsEnd = String(max <= 8 || pos >= max - 8);
      }

      #initRememberedSize(signal) {
        for (const panel of this.panels) {
          const key = `mg_size_${panel.dataset.sizeKey}`;
          const saved = this.#get('localStorage', key);
          if (saved) {
            const card = [...panel.querySelectorAll('[data-size-val]')].find((el) => el.dataset.sizeVal === saved);
            if (card) {
              card.classList.add('is-mine');
              const note = document.createElement('span');
              note.className = 'mg-sbs__sr';
              note.textContent = ', your last size';
              card.append(note);
            }
          }
          panel.addEventListener('click', (event) => {
            const card = event.target.closest('a[data-size-val]');
            if (card && !card.classList.contains('is-empty')) this.#set('localStorage', key, card.dataset.sizeVal);
          }, { signal });
        }
      }

      /**
       * Live counts straight from Search & Discovery: fetch each tab's collection through the
       * internal "mg-size-counts" section (Section Rendering API), then match every pill's
       * filter parameter + value. Same numbers as the filter sidebar, with no product limit.
       */
      // Fetch counts only once the section is near the viewport, and only for the open tab;
      // other tabs fetch when they're opened. Shoppers who never scroll here cost nothing.
      #watchCounts() {
        const start = () => {
          this.#countsStarted = true;
          this.#loadCounts(this.panels.find((panel) => !panel.hidden) || this.panels[0]);
        };
        if (!('IntersectionObserver' in window)) return start();
        this.#countsObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.#countsObserver.disconnect();
          start();
        }, { rootMargin: '400px 0px' });
        this.#countsObserver.observe(this);
      }

      async #loadCounts(panel) {
        const url = panel?.dataset.countUrl;
        if (!url || this.#countsLoaded.has(url)) return;
        this.#countsLoaded.add(url);
        const panels = this.panels.filter((p) => p.dataset.countUrl === url);
        try {
          const filters = await this.#fetchFilters(url, this.#abort.signal);
          for (const p of panels) this.#applyCounts(p, filters);
        } catch (error) {
          // Aborted (section moved/re-rendered in the editor): allow a fresh load on reconnect
          if (error.name === 'AbortError') {
            this.#countsLoaded.delete(url);
            return;
          }
          for (const p of panels) p.querySelectorAll('[data-count]').forEach((el) => el.remove());
        }
      }

      async #fetchFilters(url, signal) {
        const cacheKey = `mg_sbs_counts_${url}`;
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached && Date.now() - cached.t < 5 * 60 * 1000) return cached.filters;
        } catch (e) { /* ignore */ }

        const requestUrl = new URL(url, window.location.origin);
        requestUrl.searchParams.set('section_id', 'mg-size-counts');
        const response = await fetch(requestUrl, { signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const json = doc.querySelector('[data-mg-filter-counts]');
        if (!json) throw new Error('mg-size-counts section missing');
        const { filters, total } = JSON.parse(json.textContent);

        this.#set('sessionStorage', cacheKey, JSON.stringify({ t: Date.now(), filters, total }));
        return filters;
      }

      #applyCounts(panel, filters) {
        const params = new Map();
        for (const filter of filters) {
          const values = new Map();
          for (const v of filter.values) values.set(String(v.value).trim().toLowerCase(), v.count);
          params.set(filter.param.toLowerCase(), values);
        }

        let matched = 0;
        for (const card of panel.querySelectorAll('a[data-size-val]')) {
          const countEl = card.querySelector('[data-count]');
          let key = null;
          let value = null;
          try {
            for (const [k, v] of new URL(card.getAttribute('href'), window.location.origin).searchParams) {
              if (k.startsWith('filter.') && !k.startsWith('filter.v.price')) {
                key = k.toLowerCase();
                value = v.trim().toLowerCase();
                break;
              }
            }
          } catch (e) { /* malformed link */ }

          const values = key ? params.get(key) : null;
          if (!values) {
            countEl?.remove();
            continue;
          }
          const count = values.get(value) ?? 0;
          if (values.has(value)) matched += 1;
          this.#renderCount(card, countEl, count);
        }

        if (!matched && window.Shopify?.designMode) {
          console.warn('[MG Shop by size] No size values matched the Search & Discovery filter values for', panel.dataset.countUrl);
        }
      }

      #renderCount(card, countEl, count) {
        const { emptyMode, labelOne, labelMany, labelSold, labelRequest } = this.dataset;
        const setText = (text) => {
          if (!countEl) return;
          countEl.replaceChildren();
          const sr = document.createElement('span');
          sr.className = 'mg-sbs__sr';
          sr.textContent = ', ';
          countEl.append(sr, text);
        };

        if (count > 0) {
          setText(count === 1 ? labelOne : labelMany.replace('[count]', count));
          return;
        }

        card.classList.add('is-empty');
        if (emptyMode === 'hide') {
          card.closest('li').hidden = true;
        } else if (emptyMode === 'whatsapp' && card.dataset.waHref) {
          card.href = card.dataset.waHref;
          card.target = '_blank';
          card.rel = 'noopener noreferrer';
          setText(labelRequest);
          const sr = document.createElement('span');
          sr.className = 'mg-sbs__sr';
          sr.textContent = ' on WhatsApp (opens in a new tab)';
          card.append(sr);
        } else {
          card.removeAttribute('href');
          card.setAttribute('role', 'link');
          card.setAttribute('aria-disabled', 'true');
          setText(labelSold);
        }
      }

      // Takes the storage name: merely reading window.localStorage throws when cookies are blocked
      #get(store, key) {
        try { return window[store].getItem(key); } catch (e) { return null; }
      }

      #set(store, key, value) {
        try { window[store].setItem(key, value); } catch (e) { /* storage blocked */ }
      }
    }

    customElements.define('mg-shop-by-size', MgShopBySize);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-reviews')) {
    /**
     * Reviews & videos.
     * - Only one video plays at a time. With autoplay on, the most visible card plays muted;
     *   a card the shopper starts themselves keeps playing until it scrolls out of view.
     * - Autoplay is skipped for reduced-motion and data-saver users.
     * - All listeners/observers are cleaned up on disconnect (theme editor re-renders).
     */
    class MgReviews extends HTMLElement {
      #abort = null;
      #io = null;
      #posterIo = null;
      #ro = null;
      #raf = 0;
      #ratios = new Map();
      #current = null;
      #manual = null;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;
        const loop = this.dataset.loop === 'true';

        this.cards = [...this.querySelectorAll('[data-rv-card]')];
        this.videoCards = this.cards.filter((card) => card.querySelector('video'));

        for (const card of this.videoCards) {
          const video = card.querySelector('video');
          video.loop = loop;
          video.muted = true;
          video.removeAttribute('autoplay');
          this.#bindCard(card, video, signal);
        }

        for (const btn of this.querySelectorAll('[data-more-btn]')) {
          btn.addEventListener('click', (event) => {
            event.stopPropagation();
            const sheet = btn.closest('.mg-reviews__sheet');
            const expanded = sheet.classList.toggle('is-expanded');
            btn.setAttribute('aria-expanded', String(expanded));
            btn.textContent = expanded ? 'Show less' : btn.dataset.label || btn.textContent;
          }, { signal });
          btn.dataset.label = btn.textContent.trim();
        }

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = navigator.connection?.saveData === true;
        this.autoplay = this.hasAttribute('data-autoplay') && !reduceMotion && !saveData;

        if (this.videoCards.length && 'IntersectionObserver' in window) {
          this.#io = new IntersectionObserver((entries) => this.#onIntersect(entries), { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });
          this.videoCards.forEach((card) => this.#io.observe(card));

          // Lazy posters: fetch every cover once the section is ~300px from the viewport
          // (all at once, so cards swiped in from the side never appear blank)
          this.#posterIo = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.#posterIo.disconnect();
            this.videoCards.forEach((card) => this.#loadPoster(card.querySelector('video')));
          }, { rootMargin: '300px 0px' });
          this.#posterIo.observe(this);
        } else {
          this.videoCards.forEach((card) => this.#loadPoster(card.querySelector('video')));
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden && this.#current) this.#pause(this.#current);
        }, { signal });

        if (this.hasAttribute('data-scroll')) this.#bindFade(signal);
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#io?.disconnect();
        this.#posterIo?.disconnect();
        this.#ro?.disconnect();
        cancelAnimationFrame(this.#raf);
        this.videoCards?.forEach((card) => card.querySelector('video')?.pause());
      }

      #bindCard(card, video, signal) {
        const playBtn = card.querySelector('[data-play-btn]');
        const muteBtn = card.querySelector('[data-mute-btn]');
        const fsBtn = card.querySelector('[data-fullscreen-btn]');
        const seek = card.querySelector('[data-seek]');

        playBtn?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.#toggle(card);
        }, { signal });

        // Tap anywhere on the media (not on controls, links or the review text) toggles playback
        card.addEventListener('click', (event) => {
          if (event.target.closest('button, a, input, .mg-reviews__sheet')) return;
          this.#toggle(card);
        }, { signal });

        muteBtn?.addEventListener('click', (event) => {
          event.stopPropagation();
          const soundOn = video.muted;
          if (soundOn) {
            for (const other of this.videoCards) {
              if (other !== card) this.#setMuted(other, true);
            }
            if (video.paused) this.#play(card, { manual: true });
          }
          this.#setMuted(card, !soundOn);
        }, { signal });

        fsBtn?.addEventListener('click', (event) => {
          event.stopPropagation();
          if (video.paused) this.#play(card, { manual: true });
          if (video.requestFullscreen) video.requestFullscreen().catch(() => {});
          else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
        }, { signal });

        if (seek) {
          const paint = () => seek.style.setProperty('--pct', `${seek.value / 10}%`);
          video.addEventListener('timeupdate', () => {
            if (!video.duration || seek.matches(':active')) return;
            seek.value = Math.round((video.currentTime / video.duration) * 1000);
            paint();
          }, { signal });
          seek.addEventListener('input', (event) => {
            event.stopPropagation();
            if (video.duration) video.currentTime = (seek.value / 1000) * video.duration;
            paint();
          }, { signal });
          seek.addEventListener('click', (event) => event.stopPropagation(), { signal });
        }

        video.addEventListener('play', () => this.#setPlaying(card, true), { signal });
        video.addEventListener('pause', () => this.#setPlaying(card, false), { signal });
        video.addEventListener('ended', () => {
          if (!video.loop) {
            video.currentTime = 0;
            if (this.#manual === card) this.#manual = null;
          }
        }, { signal });
      }

      #toggle(card) {
        const video = card.querySelector('video');
        if (video.paused) {
          card.dataset.userPaused = '';
          this.#play(card, { manual: true });
        } else {
          card.dataset.userPaused = 'true';
          this.#pause(card);
          if (this.#manual === card) this.#manual = null;
        }
      }

      #loadPoster(video) {
        if (video?.dataset.poster && !video.poster) video.poster = video.dataset.poster;
      }

      #play(card, { manual = false } = {}) {
        const video = card.querySelector('video');
        this.#loadPoster(video);
        for (const other of this.videoCards) {
          if (other !== card) this.#pause(other);
        }
        if (manual) this.#manual = card;
        this.#current = card;
        video.play().catch(() => {});
      }

      #pause(card) {
        const video = card.querySelector('video');
        if (!video.paused) video.pause();
        if (this.#current === card) this.#current = null;
      }

      #setPlaying(card, playing) {
        card.classList.toggle('is-playing', playing);
        const btn = card.querySelector('[data-play-btn]');
        if (btn) btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      #setMuted(card, muted) {
        const video = card.querySelector('video');
        video.muted = muted;
        card.querySelector('[data-mute-btn]')?.setAttribute('aria-pressed', String(!muted));
      }

      #onIntersect(entries) {
        for (const entry of entries) {
          const ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          this.#ratios.set(entry.target, ratio);

          // Scrolled (mostly) away: stop it and release the manual lock
          if (ratio < 0.25) {
            this.#pause(entry.target);
            if (this.#manual === entry.target) this.#manual = null;
            delete entry.target.dataset.userPaused;
          }
        }

        if (!this.autoplay || this.#manual) return;

        let best = null;
        let bestRatio = 0.6;
        for (const card of this.videoCards) {
          const ratio = this.#ratios.get(card) || 0;
          if (ratio >= bestRatio && card.dataset.userPaused !== 'true') {
            best = card;
            bestRatio = ratio + 0.001; // the first (left-most) card wins ties
          }
        }
        if (best && best !== this.#current) {
          this.#setMuted(best, true);
          this.#play(best);
        }
      }

      #bindFade(signal) {
        const list = this.querySelector('[data-rv-list]');
        if (!list) return;
        const update = () => {
          const max = list.scrollWidth - list.clientWidth;
          const scrollable = getComputedStyle(list).overflowX !== 'visible' && max > 2;
          this.dataset.overflow = String(scrollable);
          this.dataset.atEnd = String(!scrollable || Math.abs(list.scrollLeft) >= max - 4);
        };
        list.addEventListener('scroll', update, { passive: true, signal });
        // ResizeObserver fires once right after the first layout, so measuring there never forces a reflow
        if ('ResizeObserver' in window) {
          this.#ro = new ResizeObserver(update);
          this.#ro.observe(list);
        } else {
          this.#raf = requestAnimationFrame(update);
        }
      }
    }

    customElements.define('mg-reviews', MgReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-top-searched"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-top-searched')) {
    /** Mobile carousel edge fade. No-op for masonry layouts. */
    class MgTopSearched extends HTMLElement {
      #abort = null;
      #observer = null;
      #frame = 0;

      connectedCallback() {
        if (!this.hasAttribute('data-scroll')) return;
        const list = this.querySelector('[data-ts-list]');
        if (!list) return;

        this.#abort = new AbortController();
        // overflow-x only changes across breakpoints, so it is re-read on resize, not on every scroll
        let overflows = null;
        const update = () => {
          this.#frame = 0;
          if (overflows === null) overflows = getComputedStyle(list).overflowX !== 'visible';
          const max = list.scrollWidth - list.clientWidth;
          const scrollable = overflows && max > 2;
          this.dataset.overflow = String(scrollable);
          this.dataset.atEnd = String(!scrollable || Math.abs(list.scrollLeft) >= max - 4);
        };
        // Scroll updates are batched into one animation frame
        const request = () => {
          if (!this.#frame) this.#frame = requestAnimationFrame(update);
        };
        list.addEventListener('scroll', request, { passive: true, signal: this.#abort.signal });
        // ResizeObserver fires once right after the first layout, so measuring there never forces a reflow
        if ('ResizeObserver' in window) {
          this.#observer = new ResizeObserver(() => {
            overflows = null;
            update();
          });
          this.#observer.observe(list);
        } else {
          request();
        }
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#observer?.disconnect();
        if (this.#frame) cancelAnimationFrame(this.#frame);
        this.#frame = 0;
      }
    }

    customElements.define('mg-top-searched', MgTopSearched);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-whatsapp-float"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mg-wa-float')) {
    /**
     * Floating WhatsApp chat. Lifecycle-safe in the theme editor: all listeners are
     * bound to an AbortController and removed when the section re-renders/unloads.
     */
    class MgWaFloat extends HTMLElement {
      #abort = null;
      #autoTimer = 0;
      #typingTimer = 0;
      #hasOpened = false;
      #product = null;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        this.trigger = this.querySelector('[data-wa-toggle]');
        this.card = this.querySelector('[data-wa-card]');
        this.input = this.querySelector('[data-wa-input]');
        this.sendLink = this.querySelector('[data-wa-send]');
        this.attach = this.querySelector('[data-wa-attach]');
        this.chips = [...this.querySelectorAll('[data-chip]')];
        this.isEditor = Boolean(window.Shopify && window.Shopify.designMode);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const productJson = this.querySelector('[data-wa-product]');
        if (productJson) {
          try { this.#product = JSON.parse(productJson.textContent); } catch (e) { this.#product = null; }
        }

        if (!this.isEditor && this.#storageGet(this.#key('badge'))) this.classList.add('is-badge-dismissed');

        this.#applyHours();
        this.#stampTime();
        this.#syncHref();

        this.trigger?.addEventListener('click', () => this.toggle(), { signal });
        // Warm the card's images on intent (hover / keyboard focus) so they're ready when it opens
        this.trigger?.addEventListener('pointerenter', () => this.#hydrateImages(), { once: true, signal });
        this.trigger?.addEventListener('focus', () => this.#hydrateImages(), { once: true, signal });
        this.querySelector('[data-wa-close]')?.addEventListener('click', () => this.close(true), { signal });

        for (const link of this.querySelectorAll('[data-wa-link]')) {
          link.addEventListener('click', () => {
            this.#syncHref();
            this.#dismissBadge();
            this.#track(link.dataset.waLink);
          }, { signal });
        }

        this.input?.addEventListener('input', () => this.#syncHref(), { signal });
        this.input?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || event.isComposing) return;
          event.preventDefault();
          this.sendLink?.click();
        }, { signal });
        this.attach?.addEventListener('change', () => this.#syncHref(), { signal });

        for (const chip of this.chips) {
          chip.addEventListener('click', () => this.#selectChip(chip), { signal });
        }

        document.addEventListener('pointerdown', (event) => {
          if (this.classList.contains('is-open') && !this.contains(event.target)) this.close(false);
        }, { signal });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close(true);
        }, { signal });

        // Theme editor: open the card while the section is selected
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.open({ focus: false });
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.close(false);
        }, { signal });

        this.#scheduleAutoOpen();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        clearTimeout(this.#autoTimer);
        clearTimeout(this.#typingTimer);
      }

      toggle() {
        if (this.classList.contains('is-open')) {
          this.close(true);
        } else {
          this.open({ focus: true });
        }
      }

      open({ focus = true } = {}) {
        if (!this.card) return;
        clearTimeout(this.#autoTimer);
        this.#hydrateImages();
        this.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
        this.#dismissBadge();
        this.#playTyping();
        this.#track('open');

        if (!focus) return;
        // On phones, focusing the input would pop the keyboard over the card — focus the dialog instead
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        const target = isDesktop && this.input ? this.input : this.card;
        setTimeout(() => target.focus({ preventScroll: true }), 120);
      }

      close(returnFocus) {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (returnFocus) this.trigger?.focus();
      }

      /** Swap each <template data-wa-defer> for its image the first time the card is needed */
      #hydrateImages() {
        for (const template of this.querySelectorAll('template[data-wa-defer]')) {
          template.replaceWith(template.content.cloneNode(true));
        }
      }

      #selectChip(chip) {
        for (const other of this.chips) other.setAttribute('aria-pressed', String(other === chip));
        if (this.attach && chip.hasAttribute('data-chip-attach')) this.attach.checked = true;
        if (this.input) {
          this.input.value = chip.dataset.chip || '';
          this.input.focus({ preventScroll: true });
          const end = this.input.value.length;
          this.input.setSelectionRange(end, end);
        }
        this.#syncHref();
      }

      #currentVariantId() {
        // Only trust ids that belong to this product: the page can also hold add-to-cart forms
        // for other products (cart drawer upsells, recommendations, quick add).
        const variants = this.#product?.variants || {};
        for (const input of document.querySelectorAll('form[action*="/cart/add"] [name="id"]')) {
          if (input.value && variants[input.value]) return input.value;
        }
        const fromUrl = new URL(window.location.href).searchParams.get('variant');
        if (fromUrl && variants[fromUrl]) return fromUrl;
        return String(this.#product?.selected || '');
      }

      #composeMessage() {
        const typed = this.input ? this.input.value.trim() : '';
        const product = this.#product;

        if (!product || !this.attach?.checked) return typed || this.dataset.defaultMessage || '';

        const variantId = this.#currentVariantId();
        const variant = product.variants?.[variantId];
        const url = new URL(product.url);
        if (variantId) url.searchParams.set('variant', variantId);

        const lines = [typed || product.intro, '', `• ${product.title}`];
        if (variant && variant.title !== 'Default Title') lines.push(`• Option: ${variant.title}`);
        if (variant?.price) lines.push(`• Price: ${variant.price}`);
        lines.push(url.toString());
        return lines.join('\n');
      }

      #syncHref() {
        if (!this.sendLink) return;
        const text = this.#composeMessage();
        // encodeURIComponent (not URLSearchParams) so spaces become %20, not "+", in the WhatsApp message
        this.sendLink.href = `https://wa.me/${this.dataset.phone}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
      }

      #playTyping() {
        if (this.#hasOpened || this.reducedMotion || this.isEditor) {
          this.#hasOpened = true;
          return;
        }
        this.#hasOpened = true;
        this.card.classList.add('is-typing');
        this.#typingTimer = setTimeout(() => this.card.classList.remove('is-typing'), 700);
      }

      #applyHours() {
        const { hoursOpen, hoursClose, hoursTz, offlineStatus } = this.dataset;
        if (hoursOpen === undefined || hoursClose === undefined) return;

        const open = Number(hoursOpen);
        const close = Number(hoursClose);
        let hour;
        try {
          hour = Number(new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hourCycle: 'h23', timeZone: hoursTz }).format(new Date()));
        } catch (e) {
          return;
        }

        let isOpen = true;
        if (open < close) isOpen = hour >= open && hour < close;
        else if (open > close) isOpen = hour >= open || hour < close; // overnight hours

        this.classList.toggle('is-offline', !isOpen);
        const status = this.querySelector('[data-wa-status]');
        if (!isOpen && status && offlineStatus) status.textContent = offlineStatus;
      }

      #stampTime() {
        const el = this.querySelector('[data-wa-time]');
        if (!el) return;
        el.textContent = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(new Date());
      }

      #scheduleAutoOpen() {
        const delay = Number(this.dataset.autoOpen);
        if (!delay || !this.card || this.isEditor) return;
        if (this.#storageGet(this.#key('opened'))) return;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (isMobile && !this.hasAttribute('data-auto-open-mobile')) return;

        this.#autoTimer = setTimeout(() => {
          if (this.classList.contains('is-open')) return;
          this.open({ focus: false });
          this.#storageSet(this.#key('opened'));
        }, delay * 1000);
      }

      #dismissBadge() {
        this.classList.add('is-badge-dismissed');
        if (!this.isEditor) this.#storageSet(this.#key('badge'));
      }

      #track(action) {
        const detail = { action, category: this.dataset.category, page: window.location.pathname };
        this.dispatchEvent(new CustomEvent('mg:whatsapp', { detail, bubbles: true }));
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'mg_whatsapp', ...detail });
        try { window.Shopify?.analytics?.publish?.('mg_whatsapp', detail); } catch (e) { /* analytics is optional */ }
      }

      #key(name) {
        return `mg_wa_${name}_${this.dataset.sectionId}`;
      }

      #storageGet(key) {
        try { return sessionStorage.getItem(key); } catch (e) { return null; }
      }

      #storageSet(key) {
        try { sessionStorage.setItem(key, '1'); } catch (e) { /* private mode */ }
      }
    }

    customElements.define('mg-wa-float', MgWaFloat);
  }

  } catch(e) { console.error(e); }
})();
})();
